<template>
  <div :class="dropdownClasses" ref="root">
    <div class="dropdown-trigger">
      <slot name="dropdown-trigger" :handleToggle="toggle">
        <button :class="buttonClasses" @click="toggle">
          {{ buttonTitle }}
        </button>
      </slot>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <slot></slot>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'BaseDropdown',

  model: {
    prop: 'isOpen',
    event: 'update:isOpen'
  },

  props: {
    buttonTitle: {
      type: String,
      default: 'Click'
    },
    buttonClasses: {
      type: [String, Object, Array],
      default: 'button'
    },
    wrapperClasses: {
      type: [String, Object, Array],
      default: ''
    },
    onDialogClose: {
      type: Function,
      default: () => {}
    },
    onDialogChange: {
      type: Function,
      default: (e) => {}
    },
    isOpen: {
      type: Boolean
    }
  },

  data () {
    return {
      triggered: this.isOpen
    }
  },

  computed: {
    dropdownClasses () {
      return ['dropdown', this.wrapperClasses, ...[this.triggered ? 'is-active' : '']]
    }
  },

  watch: {
    isOpen (val) {
      this.triggered = val
    }
  },

  // listen for clicks anywhere in the document
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    handleClickOutside (event) {
      // if open and click target is outside our root element...
      if (this.triggered && !this.$refs.root.contains(event.target)) {
        this.triggered = false
        // notify parent
        this.$emit('update:isOpen', false)
        // call callback
        this.onDialogClose(event, this.toggle)
      }
    },

    toggle () {
      this.triggered = !this.triggered
      this.$emit('update:isOpen', this.triggered)
    },

    onChangeHandler (e) {
      // logic to run when form change
      this.onDialogChange(e, this.toggleModal)
    },

    closeDialog (e) {
      // logic to run when dialog close
      this.onDialogClose(e, this.toggleModal)
    }
  }
}
</script>
